// 开发预览页（T3.V 用）：无鉴权，渲染 V2 13 版式 mock + legacy 旧 deck 样张回归
// 用法：/v2preview?i=3 单页（0 起）；/v2preview 全览
import SlideCanvas from "../components/SlideCanvas";
import type { SlideContent } from "../lib/slides";
import { getTheme } from "../lib/tokens.generated";

const MOCK: SlideContent[] = [
  { layout: "cover", layoutV2: "cover", title: "活泉安肌舒缓面膜霜营销方案", subtitle: "敏感肌修护颜究院 · 新品上市 6 个月破圈计划", blocks: [] },
  { layout: "concept", layoutV2: "divider", title: "市场洞察", subtitle: "敏感肌护理赛道的机会窗口", blocks: [] },
  { layout: "concept", layoutV2: "statement", title: "核心主张", blocks: [{ type: "quote", text: "止痒退红，修护屏障", cite: "活泉产品宣言" }] },
  { layout: "data", layoutV2: "kpi-hero", title: "赛道关键数字", blocks: [
    { type: "metric", label: "敏感肌护理市场规模", value: "128亿" },
    { type: "metric", label: "年复合增长率", value: "23%" },
    { type: "metric", label: "6 个月销售目标", value: "3000万" },
    { type: "metric", label: "目标转化率", value: "4.2%" },
  ] },
  { layout: "data", layoutV2: "bar-chart", title: "各渠道 GMV 占比", blocks: [
    { type: "chart", items: [
      { label: "抖音电商", value: 42, unit: "%" }, { label: "天猫旗舰店", value: 28, unit: "%" },
      { label: "小红书商城", value: 14, unit: "%" }, { label: "线下 CS 渠道", value: 9, unit: "%" },
      { label: "私域小程序", value: 5, unit: "%" }, { label: "其他", value: 2, unit: "%" },
    ] },
  ] },
  { layout: "insight", layoutV2: "duo-compare", title: "活泉 vs 主流竞品", blocks: [
    { type: "compare",
      left: { title: "主流竞品", items: ["化学成分舒缓，刺激风险", "泛敏感肌定位，人群宽泛", "依赖明星代言，成本高", "复购率约 18%"] },
      right: { title: "活泉", items: ["物理舒缓配方，0 刺激", "专注干敏肌，精准切入", "成分党 KOC 口碑驱动", "目标复购率 35%"] } },
  ] },
  { layout: "roadmap", layoutV2: "timeline-h", title: "上市四步节奏", blocks: [
    { type: "timeline", items: [
      { title: "种草蓄水", desc: "第 1-2 月 · KOC 测评矩阵" }, { title: "首发引爆", desc: "第 3 月 · 抖音超品日" },
      { title: "口碑发酵", desc: "第 4-5 月 · 素人 UGC 裂变" }, { title: "复购沉淀", desc: "第 6 月 · 私域会员体系" },
    ] },
  ] },
  { layout: "roadmap", layoutV2: "timeline-v", title: "品牌演进路线", blocks: [
    { type: "timeline", items: [
      { title: "单品破局", desc: "面膜霜建立专业心智" }, { title: "品类延伸", desc: "舒缓精华/洁面补齐" },
      { title: "体系成型", desc: "敏感肌修护全方案" }, { title: "品类代表", desc: "成为干敏肌首选品牌" },
    ] },
    { type: "metric", label: "3 年目标营收", value: "2.4亿" },
  ] },
  { layout: "strategy", layoutV2: "cards", title: "三大核心策略", blocks: [
    { type: "cards", items: [
      { title: "专业背书", desc: "皮肤科医生共创内容，建立修护权威" },
      { title: "场景切入", desc: "换季敏感高发期集中引爆" },
      { title: "口碑复利", desc: "真实用户实测数据反哺投放" },
    ] },
  ] },
  { layout: "channel", layoutV2: "matrix", title: "渠道功能盘点", blocks: [
    { type: "cards", items: [
      { title: "抖音", desc: "引爆主阵地" }, { title: "小红书", desc: "种草决策场" },
      { title: "天猫", desc: "转化收口" }, { title: "私域", desc: "复购引擎" },
      { title: "线下", desc: "体验背书" }, { title: "得物", desc: "年轻人群补量" },
    ] },
  ] },
  { layout: "financial", layoutV2: "ledger", title: "首季预算拆解", blocks: [
    { type: "ledger", items: [
      { name: "内容制作", value: "60万", note: "KOC 测评与素材" },
      { name: "效果投放", value: "140万", note: "千川+随心推" },
      { name: "达人合作", value: "55万", note: "腰部 KOL 组合" },
      { name: "平台活动", value: "30万", note: "超品日资源位" },
      { name: "机动预留", value: "15万", note: "A/B 测试追加" },
      { name: "合计", value: "300万" },
    ] },
  ] },
  { layout: "strategy", layoutV2: "image-text", title: "使用场景沟通", blocks: [
    { type: "image", prompt: "深夜护肤场景：暖光台灯下，年轻女性涂抹乳白色面霜，背景虚化，氛围安静治愈" },
    { type: "bullets", items: ["换季泛红刺痛时的急救厚敷", "医美术后 7 天修护搭档", "空调房干敏日常保湿"] },
  ] },
  { layout: "vision", layoutV2: "closing", title: "让干敏肌人群不再试错", blocks: [
    { type: "bullets", items: ["6 个月 3000 万销售达成", "复购率 35% 进入良性循环", "成为敏感肌修护品类首选"] },
  ] },
  // ---- 主题库扩展 v1.1 数据组件 5 版式（T5.V 用，043 §4.10）----
  { layout: "financial", layoutV2: "waterfall", title: "首季投放预算桥", blocks: [
    { type: "waterfall", unit: "万", items: [
      { label: "内容制作", delta: 60 }, { label: "效果投放", delta: 140 }, { label: "达人合作", delta: 55 },
      { label: "退货退款", delta: -8 }, { label: "平台活动", delta: 30 }, { label: "机动预留", delta: 23 },
      { label: "总预算", delta: null },
    ] },
  ] },
  { layout: "roadmap", layoutV2: "gantt", title: "上市节奏六步泳道", blocks: [
    { type: "gantt", ticks: ["3月", "4月", "5月", "6月", "7月", "8月"], lanes: ["线上", "线下"], tasks: [
      { label: "种草蓄水", start: 0, end: 2, lane: 0 }, { label: "首发引爆", start: 1, end: 3, lane: 0 },
      { label: "门店体验", start: 1, end: 2, lane: 1 }, { label: "口碑发酵", start: 2, end: 4, lane: 1 },
      { label: "复购沉淀", start: 3, end: 5, lane: 0 },
    ] },
  ] },
  { layout: "data", layoutV2: "funnel", title: "转化漏斗五层", blocks: [
    { type: "funnel", unit: "万", tiers: [
      { label: "曝光", value: 1200 }, { label: "点击", value: 320 }, { label: "进店", value: 96 },
      { label: "加购", value: 24 }, { label: "成交", value: 9.6 },
    ] },
  ] },
  { layout: "data", layoutV2: "dumbbell", title: "核心指标前后对比", blocks: [
    { type: "dumbbell", hero: 1, items: [
      { name: "品牌认知度", before: 12, after: 35, lo: 0, hi: 50, unit: "%" },
      { name: "复购率", before: 18, after: 35, lo: 0, hi: 50, unit: "%" },
      { name: "客单价", before: 86, after: 120, lo: 50, hi: 150, unit: "元" },
      { name: "渠道覆盖", before: 8, after: 3, lo: 0, hi: 10, unit: "个" },
    ] },
  ] },
  { layout: "data", layoutV2: "bullet", title: "季度 KPI 目标带", blocks: [
    { type: "bullet", items: [
      { label: "销售额", actual: 2100, target: 3000, max: 3360 }, { label: "ROI", actual: 2.33, target: 3.0 },
      { label: "复购率", actual: 31, target: 35 }, { label: "转化率", actual: 3.2, target: 4.2 },
    ] },
  ] },
];

// 旧 deck（legacy）真实数据抽样：回归验证旧渲染分支
const LEGACY: SlideContent[] = [
  { layout: "concept", title: "稚嫩守护：用专业温和，守护每一次户外探索", subtitle: "Big Idea", notes: "", blocks: [
    { type: "text", text: "以专研儿童肌肤为基底，用温和无刺激的防晒与护理，守护孩子稚嫩肌肤的每一次户外探索。" },
  ] },
  { layout: "insight", title: "市场洞察", blocks: [
    { type: "bullets", items: ["占位行业趋势", "占位竞品格局", "占位人群痛点"] },
  ] },
];

export default function V2Preview() {
  const q = new URLSearchParams(location.search);
  const iParam = q.get("i");
  const theme = q.get("theme") ?? "swiss-ikb";
  // 风格从主题定义推导（支持 luxe-noir；原二元判断会把 luxe 误标 swiss——虽不影响渲染分发，但语义错误）
  const style = getTheme(theme).style;

  if (iParam !== null) {
    const i = Number(iParam);
    // 045 #25：越界/非法 i 保护（原 MOCK[i] 越界直接崩溃）
    if (!Number.isInteger(i) || i < 0) {
      return <div style={{ padding: 24, color: "#fff" }}>越界：不存在 i={iParam} 的样张页</div>;
    }
    if (i >= 100) {
      const s = LEGACY[i - 100];
      if (!s) return <div style={{ padding: 24, color: "#fff" }}>越界：不存在 i={iParam} 的 legacy 样张页</div>;
      return <SlideCanvas slide={s} pageIdx={i - 99} style="legacy" />;
    }
    const s = MOCK[i];
    if (!s) return <div style={{ padding: 24, color: "#fff" }}>越界：不存在 i={iParam} 的样张页</div>;
    return <SlideCanvas slide={s} pageIdx={i + 1} style={style} themeId={theme} totalPages={MOCK.length} />;
  }
  return (
    <div style={{ background: "#888", padding: 12 }}>
      {MOCK.map((s, i) => (
        <div key={i} style={{ marginBottom: 12 }}>
          <div style={{ color: "#fff", fontSize: 12 }}>{i + 1} · {s.layoutV2}</div>
          <SlideCanvas slide={s} pageIdx={i + 1} style={style} themeId={theme} totalPages={MOCK.length} />
        </div>
      ))}
    </div>
  );
}
